// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__1gNwU","signatureButtonsRight":"ModalSign_signatureButtonsRight__eYYLS"};